import React from 'react';
import PropTypes from 'prop-types';
import { FooterLinks } from 'components';
import { EditorWeb, EditoriOS, EditorAndroid } from './';

const docsUrlList = [
  'https://auth0.com/docs/libraries/lock',
  'https://auth0.com/docs/libraries/lock-ios',
  'https://auth0.com/docs/libraries/lock-android'
];

const Editor = ({
    selectedLanguageIndex, onOptionChange, options, defaultColor, logos, optionsString
  }) => {
  const editorProps = { onOptionChange, options, logos, defaultColor };
  const editorTypesList = [
    <EditorWeb {...editorProps} />,
    <EditoriOS {...editorProps} />,
    <EditorAndroid {...editorProps} />
  ];

  return (
    <div className="editor">
      <div className="code">
        {editorTypesList[selectedLanguageIndex]}
        <img
          src="https://cdn.auth0.com/website/playground/others/mobile-lock-example.svg"
          className="phone-example"
          alt="Phone with lock example"
        />
      </div>
      <FooterLinks
        docsUrl={docsUrlList[selectedLanguageIndex]}
        optionsString={optionsString}
      />
    </div>
  );
};

Editor.propTypes = {
  selectedLanguageIndex: PropTypes.number.isRequired,
  onOptionChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  preset: PropTypes.string.isRequired,
  logoBaseUrl: PropTypes.string,
  defaultColor: PropTypes.string,
  logos: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired
  }).isRequired),
  hideName: PropTypes.bool,
  optionsString: PropTypes.string.isRequired
};

export default Editor;



// WEBPACK FOOTER //
// ./src/components/Editor/Editor.js


// WEBPACK FOOTER //
// webpack:///src/components/Editor/Editor.js